import { render, staticRenderFns } from "./PromotionsBanner.vue?vue&type=template&id=76190738&scoped=true&"
import script from "./PromotionsBanner.vue?vue&type=script&lang=ts&"
export * from "./PromotionsBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76190738",
  null
  
)

export default component.exports